import * as React from "react";
import { useMemo, useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { RowContainer } from "components/lookup-tables/layout-componets";
import DataAdapterForm from "./AdapterForm";
import DataAdapterTypeSelect from "./AdapterTypeSelect";
const UseExistingButton = styled(Button)`
  margin-top: 1.57rem;
`;
const DataAdapterFormView = ({ saved = void 0, onCancel, adapter = void 0, isStep = false }) => {
  var _a;
  const [dataAdapter, setDataAdapter] = useState(adapter);
  const isCreate = useMemo(() => !(dataAdapter == null ? void 0 : dataAdapter.id), [dataAdapter]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isCreate && /* @__PURE__ */ React.createElement(RowContainer, null, /* @__PURE__ */ React.createElement(
    DataAdapterTypeSelect,
    {
      adapterConfigType: dataAdapter ? dataAdapter.config.type : null,
      onAdapterChange: setDataAdapter
    }
  ), isStep && /* @__PURE__ */ React.createElement(UseExistingButton, { onClick: onCancel }, "Use Existing Data Adapter")), dataAdapter && /* @__PURE__ */ React.createElement(
    DataAdapterForm,
    {
      dataAdapter,
      type: (_a = dataAdapter == null ? void 0 : dataAdapter.config) == null ? void 0 : _a.type,
      create: isCreate,
      title: "Configure Adapter",
      saved,
      onCancel
    }
  ));
};
export default DataAdapterFormView;
